<!--
 * @Description: 测试
 * @Date: 2024-12-12 11:40:40
-->
<template>
  <div>
    测试
    <div>
      <XrkButton @click="jump">实名认证完成</XrkButton>
      <XrkButton @click="close">关闭</XrkButton>
      <XrkButton @click="faceFail">人脸识别失败</XrkButton>
      <XrkButton @click="faceSuccess">人脸识别成功</XrkButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
// import { onMounted } from 'vue';
import { XrkButton } from '@/components/vant/index';

import native from '@/utils/native';

const jump = () => {
  native.method.authenticationDone();
};
const close = () => {
  native.method.close();
};

const faceFail = () => {
  native.method.faceAuthFile({ tmName: 'tmName', phone: '11111111111' });
};

const faceSuccess = () => {
  native.method.faceAuthComplete({ token: 'token', phone: '11111111111' });
};
// onMounted(() => {
//   native.method.authenticationDone();
// });
</script>
<style>
.van-button {
  color: #fff !important;
  font-size: 20px !important;
  width: 200px !important;
  margin: 20px !important;
}
</style>
